
const ThankYouMessage = () => {
  return (
    <div className="mt-12 text-center">
      <h2 className="text-2xl font-semibold mb-4">¡Gracias por tu apoyo!</h2>
      <div className="max-w-2xl mx-auto">
        <p className="text-gray-700 mb-6">
          Cada donación, sin importar su tamaño, marca una diferencia significativa en el crecimiento de SeekArt. 
          Tu contribución no solo ayuda a mejorar la plataforma, sino que también inspira a otros a unirse a esta comunidad creativa.
        </p>
        <p className="text-gray-700 font-medium">
          Con gratitud,<br />
          El equipo de SeekArt
        </p>
      </div>
    </div>
  );
};

export default ThankYouMessage;
